(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* MWB Header-Redesign 2026-09
     - .is-solid: Overlay-Header (Startseite) wird weiss ab 40px Scroll oder sobald
       irgendein details im Header offen ist (Mega-Panel, Drawer, Suche).
     - Mega-Panels: nur eines offen; Hover-Intent auf Desktop-Zeigergeraeten;
       Klick ausserhalb und Esc schliessen. Klick/Tastatur bleiben Dawn-Standard. */
  (function () {
    function init() {
      var wrap = document.querySelector('.mwb-header');
      if (!wrap || wrap.dataset.mwbInit) return;
      wrap.dataset.mwbInit = '1';
      var overlay = wrap.classList.contains('mwb-header--overlay');
      var scrolled = window.scrollY > 40;

      function megas(openOnly) {
        return Array.prototype.slice.call(wrap.querySelectorAll('details.mega-menu' + (openOnly ? '[open]' : '')));
      }
      function closeMenu(d) {
        var hm = d.closest('header-menu');
        if (hm && typeof hm.close === 'function') hm.close();
        else d.removeAttribute('open');
      }
      function closeAll() { megas(true).forEach(closeMenu); }
      function sync() {
        var open = !!wrap.querySelector('details[open]');
        wrap.classList.toggle('has-open', open);
        wrap.classList.toggle('is-solid', !overlay || scrolled || open);
      }

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var s = window.scrollY > 40;
          if (s !== scrolled) { scrolled = s; sync(); }
        });
      }, { passive: true });

      /* toggle bubbelt nicht → Capture */
      wrap.addEventListener('toggle', function (e) {
        var d = e.target;
        if (d.open && d.classList && d.classList.contains('mega-menu')) {
          megas(true).forEach(function (o) { if (o !== d) closeMenu(o); });
        }
        sync();
      }, true);

      if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
        var tOpen, tClose;
        megas(false).forEach(function (d) {
          var li = d.closest('li');
          var summary = d.querySelector('summary');
          if (!li || !summary) return;
          li.addEventListener('mouseenter', function () {
            clearTimeout(tOpen);
            clearTimeout(tClose);
            var delay = megas(true).length ? 0 : 110;
            tOpen = setTimeout(function () {
              if (d.open) return;
              d.open = true;
              summary.setAttribute('aria-expanded', 'true');
            }, delay);
          });
          li.addEventListener('mouseleave', function () { clearTimeout(tOpen); });
          /* Ein Mausklick auf den Menuepunkt klappt ein offenes Panel nie zu (es ist ja per Hover
             offen). Zu geht es beim Verlassen des Headers, Klick ausserhalb oder Esc. Tastatur
             (Enter/Leertaste, e.detail 0) klappt weiter auf und zu. Bis 28.09. galt der Schutz
             nur 700 ms nach dem Oeffnen, ein spaeterer Klick liess das Menue verschwinden. */
          summary.addEventListener('click', function (e) {
            if (d.open && e.detail > 0) {
              e.preventDefault();
              summary.setAttribute('aria-expanded', 'true');
            }
          });
        });
        wrap.addEventListener('mouseleave', function () {
          clearTimeout(tOpen);
          tClose = setTimeout(closeAll, 200);
        });
        wrap.addEventListener('mouseenter', function () { clearTimeout(tClose); });
      }

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) closeAll();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var o = megas(true)[0];
        if (!o) return;
        closeAll();
        var s = o.querySelector('summary');
        if (s) s.focus();
      });

      sync();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();
})();
